export const ModalRole = {
  Edit: 'edit',
  Delete: 'delete',
  View: 'view',
  Cancel: 'cancel',
  Backdrop: 'backdrop',
  Confirm: 'confirm',
} as const;
